var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component"},[(_vm.showMenu)?_c('SideBar',{staticClass:"generalNav"}):_c('MobileNav',{staticClass:"generalNav"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }